import { createSlice } from "@reduxjs/toolkit";

export const categorySlice= createSlice({
    name:"brand",
    initialState:{
        categoryList:[]

    },
    reducers:{
        setCategoryList:(state,action)=>{
            state.categoryList = action.payload;
        }
    }
})

export const {setCategoryList} = categorySlice.actions;
export default categorySlice.reducer; 